import ApiService from '../../../../../../services/ApiService'
import moment from 'moment'

export default {
  props: {
    filterProp: Object,
  },
  components: {},
  data() {
    return {
      apiService: new ApiService(),
      historicalMigration: undefined,
      page: 1,
      showChart: true,
      totalPages: 1,
      pageSize: 7,
      percent: 0,
      calibrationSchedule: [],
      calibrationExecuted: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      pager: {},
      historicalMigrationHeader: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Identificação',
          align: 'center',
          value: 'equipmentIdentification',
        },
        {
          text: 'Nome do equipamento',
          align: 'center',
          value: 'equipmentName',
        },
        {
          text: 'Cod. Patrimônio',
          align: 'center',
          value: 'equipmentPropertyCode',
        },
        {
          text: 'Institutição Origem',
          align: 'center',
          value: 'lastInstitutionName',
        },
        {
          text: 'Institutição Destino',
          align: 'center',
          value: 'institutionName',
        },
        {
          text: 'Unidade/Setor Origem',
          align: 'center',
          value: 'departmentSourceName',
        },
        {
          text: 'Unidade/Setor Destino',
          align: 'center',
          value: 'departmentDestinyName',
        },
        {
          text: 'Data de Migração',
          align: 'center',
          value: 'dateFormated',
        },
        {
          text: 'Motivo de Migração',
          align: 'center',
          value: 'reason',
        },
      ],
      total: 0,
      loading: false,
    }
  },
  async created() {
    this.listhistoricalMigration()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `historical_Migration_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/historicalMigration', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listhistoricalMigration() {
      this.loading = true
      await this.apiService
        .post('reports/historicalMigration', this.filterProp)
        .then((response) => {
          this.historicalMigration = []
          this.pager = response.content.pager
          this.totalPages = response.content.pager.totalPages
          this.total = response.content.pager.totalItems
          this.showChart = response.content.objects.length > 0

          response.content.objects.map((value) => {
            let dateFormated = moment(value.migretionDate).format('DD/MM/YYYY')
            this.historicalMigration.push({ ...value, dateFormated })
          })
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })

      this.fillhistoricalMigrationChartData()
    },

    fillhistoricalMigrationChartData() {
      this.historicalMigrationChartData = {
        labels: [''],
        datasets: [
          {
            label: this.$t('Calibrações Agendadas'),
            data: this.calibrationSchedule,
            backgroundColor: '#87AFA6',
          },
          {
            label: this.$t('Calibrações Executadas'),
            data: this.calibrationExecuted,
            backgroundColor: '#BAB3D3',
          },
        ],
      }
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listhistoricalMigration()
    },
  },
}
